var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppCoupon',{attrs:{"ad_mold":"coupon_for_course_detail"}})
}
var staticRenderFns = []

export { render, staticRenderFns }